import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import RootBoundary from '~/common/errors/RootBoundary.tsx';
import BaseLayout from '~/common/layouts/BaseLayout.tsx';
import EmptyLayout from '~/common/layouts/EmptyLayout.tsx';
import AuthGuard from '~/features/auth/guards/AuthGuard.tsx';

/* eslint-disable @typescript-eslint/naming-convention */
const AuthSignIn = lazy(() => import('~/pages/auth/signin'));
const AuthSignUp = lazy(() => import('~/pages/auth/signup'));
const HomePage = lazy(() => import('~/pages'));
const ManualPage = lazy(() => import('~/pages/manual'));
const MyPage = lazy(() => import('~/pages/my-page'));
const NoticesPage = lazy(() => import('~/pages/notices'));
const NoticeDetailPage = lazy(() => import('~/pages/notices/[id]'));
const ProductsPage = lazy(() => import('~/pages/products'));
const CheckoutPage = lazy(() => import('~/pages/products/[id]/checkout'));
const SupportPage = lazy(() => import('~/pages/support'));
const TermsPage = lazy(() => import('~/pages/terms'));
const PrivacyPage = lazy(() => import('~/pages/privacy'));
const WebviewPopupNoticePage = lazy(() => import('~/pages/webview-popup-notice'));
/* eslint-enable @typescript-eslint/naming-convention */

const router = createBrowserRouter([
  {
    path: '/',
    element: <BaseLayout />,
    errorElement: <RootBoundary />,
    children: [
      // Public routes
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'notices',
        element: <NoticesPage />,
      },
      {
        path: 'notices/:id',
        element: <NoticeDetailPage />,
      },
      {
        path: 'manual',
        element: <ManualPage />,
      },
      {
        path: 'products',
        element: <ProductsPage />,
      },
      {
        path: 'terms',
        element: <TermsPage />,
      },
      {
        path: 'privacy',
        element: <PrivacyPage />,
      },
      // Protected routes
      {
        element: <AuthGuard />,
        children: [
          {
            path: 'my-page',
            element: <MyPage />,
          },
          {
            path: 'products/:id/checkout',
            element: <CheckoutPage />,
          },
          {
            path: 'support',
            element: <SupportPage />,
          },
        ],
      },
    ],
  },
  {
    path: 'auth',
    element: <EmptyLayout />,
    errorElement: <RootBoundary />,
    children: [
      {
        path: 'signin',
        element: <AuthSignIn />,
      },
      {
        path: 'signup',
        element: <AuthSignUp />,
      },
    ],
  },
  {
    path: 'webview',
    element: <EmptyLayout />,
    errorElement: <RootBoundary />,
    children: [
      {
        path: 'popup-notice',
        element: <WebviewPopupNoticePage />,
      },
    ],
  },
]);

export default router;
